import { useEffect, useState } from "react";
import { Button, Typography } from "components/atoms";
import { CloseIcon } from "components/atoms/Icon";
import { Modal } from "components/molecules";
import { UpdateStatusDrillButtonSection } from "../UpdateStatusDrillButtonSection";
import { useUpdateStatusMutation } from "services/homeApi";
import "./drill-modal.scss";

interface IProps {
  handleUpdateModalClose: () => void;
  openUpdateModalState: any;
  theme: "light" | "dark";
  refetchData?: () => void;
  isFetchingOtherAPIs?: boolean;
}

interface SelectedBtnState {
  [key: string]: boolean;
  NotStarted: boolean;
  InProgress: boolean;
  Complete: boolean;
}

export const DrillModal = ({
  handleUpdateModalClose,
  openUpdateModalState,
  refetchData,
  isFetchingOtherAPIs = false,
  theme,
}: IProps) => {
  const [selectedBtn, setSelectedBtn] = useState<SelectedBtnState>({
    NotStarted: true,
    InProgress: false,
    Complete: false,
  });

  const [performUpdate, setPerformUpdate] = useState(false);

  const [isCompletedUpdateStatus, setIsCompletedUpdateStatus] = useState(false);

  const [updateStatus, { isLoading, isError, error }]: any =
    useUpdateStatusMutation();

  const handleSubmit = async (data: any, contentStatus: any) => {
    setPerformUpdate(true);
    let extractStatus = Object.entries(contentStatus).find(
      (val: any) => val[1] === true
    );
    if (data !== undefined && contentStatus !== undefined && extractStatus) {
      try {
        await updateStatus({
          CoGuid: data.ContentObjectGuid,
          progress: extractStatus?.[0],
        })
          .unwrap()
          .then(() => {
            setIsCompletedUpdateStatus(true);
            if (refetchData) {
              refetchData();
            }
          });
      } catch (error: any) {
        console.log("error : ", error);
      }
    }
  };

  const deriveTitle = (type: any): string => {
    if (type === "OfflineReading") return "Reading Assignment";
    else return "Drill";
  };

  useEffect(() => {
    if (isFetchingOtherAPIs === false && isCompletedUpdateStatus) {
      handleUpdateModalClose();
    }
  }, [isFetchingOtherAPIs, isCompletedUpdateStatus]);

  useEffect(() => {
    if (
      openUpdateModalState &&
      openUpdateModalState.data &&
      openUpdateModalState.data.Status
    ) {
      setSelectedBtn((prev: any) => {
        return {
          ...prev,
          InProgress:
            openUpdateModalState.data.Status === "In Progress" ||
            openUpdateModalState.data.Status === "InProgress" ||
            openUpdateModalState.data.Status === "In-Progress"
              ? true
              : false,
          NotStarted:
            openUpdateModalState.data.Status === "Not Started" ||
            openUpdateModalState.data.Status === "Pending"
              ? true
              : false,
          Complete:
            openUpdateModalState.data.Status === "Completed" ? true : false,
        };
      });
    }
  }, [openUpdateModalState]);

  return (
    <Modal
      onClose={() => {
        setPerformUpdate(false);
        handleUpdateModalClose();
      }}
      isOpen={openUpdateModalState.isOpen}
      theme={theme}
      style="update-status-modal-style"
    >
      <div className="update-status-modal-content-wrapper">
        <div className="update-status-modal-header-wrapper">
          <div className="title-wrapper">
            {openUpdateModalState.data !== null ? (
              <Typography
                label={deriveTitle(openUpdateModalState.data.ContentObjectType)}
                variant="h4Bold"
              />
            ) : null}
          </div>
          <CloseIcon
            onClick={() => {
              setPerformUpdate(false);
              handleUpdateModalClose();
            }}
            theme={theme}
          />
        </div>
        <div className="update-status-modal-body-wrapper">
          {openUpdateModalState.data !== null ? (
            <Typography
              variant="h6Medium"
              label={
                openUpdateModalState.data.Name ||
                openUpdateModalState.data.name ||
                openUpdateModalState.data.Title
              }
            />
          ) : null}
          <div className="btn-group-wrapper">
            <UpdateStatusDrillButtonSection
              selectedBtn={selectedBtn}
              setSelectedBtn={setSelectedBtn}
            />
          </div>
          {isError && performUpdate ? (
            <Typography
              label={`Update failed: ${error.data.Message}`}
              variant="h7Book"
              styles="custom-error-style"
            />
          ) : null}
          <div className="submit-btn-wrapper">
            <Button
              label="Done"
              icon={false}
              type="score"
              isLoading={isLoading || isFetchingOtherAPIs}
              onClick={() =>
                handleSubmit(openUpdateModalState.data, selectedBtn)
              }
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
